import { HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { download, DownloadContentWrapper } from './download';
import { Observable } from 'rxjs';
import { LiteratureApiService } from './api-services/literature-api.service';
import { SAVER, Saver } from './saver.provider';
import { DownloadRequest } from '@types';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  constructor(
    @Inject(SAVER) private save: Saver,
    private literatureApiService: LiteratureApiService
  ) {}

  public download$(
    url: string,
    reqBody: DownloadRequest
  ): Observable<DownloadContentWrapper> {
    const customHeaders = {
      headers: new HttpHeaders().set('accept', 'application/zip'),
      reportProgress: true,
      observe: 'events',
      responseType: 'blob',
    };
    return this.literatureApiService
      .download$(url, reqBody, customHeaders)
      .pipe(download((blob, filename) => this.save(blob, filename)));
  }
}
